// export default build =>
//     build.mutation({
       
//         query(payload) {
            
//             return {
               
//                 url: `/exam/getAllExamSchools`,                

//                 method: 'POST',
//                 body: payload,
//             };
          
//         },
       
//     })

export default build =>
    build.query({
        tagTypes: ['allExamSchools'],
         keepUnusedDataFor: 1,
        query(payload) {
            
            return {
                url: `/exam/getAllExamSchools?page_number=${payload.page_number}&page_size=${payload.page_size}&search=${payload.search}`,               
               // url: `/exam/getAllExamSchools`,                
                method: 'GET',
               // body: payload,
            };
          
        },
       providesTags: ['allExamSchools']
    })




